export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID
export const IS_SET_USER_ATTRIBUTE_STORAGE_KEY = 'IS_SET_USER_ATTRIBUTE'
